/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useUserStore from '../../../store/userStore/userStore';

const reportStudio = async (year: string): Promise<any> => {
  const token = useUserStore.getState().userToken;
  const userData = useUserStore.getState().userDetails;
  try {
    const response = await axios.request({
      method: CRUDMethods.GET,
      url: `${API_BASE_URL}${API_ENDPOINT_JSON.reportStudio}/${userData?.company}/${year}`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {},
      data: {}
    });

    return response?.data?.data ?? {};
  } catch (err) {
    console.log('err:', err);

    return {};
  }
};

export default reportStudio;
